import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/hizmetler', label: 'Hizmetlerimiz' },
    { path: '/universiteler', label: 'Üniversiteler' },
    { path: '/yurtlar', label: 'Öğrenci Yurtları' },
    { path: '/basvuru-sureci', label: 'Başvuru Süreci' },
    { path: '/blog', label: 'Blog' },
    { path: '/iletisim', label: 'İletişim' }
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="mailto:artyurtdisiegitim@gmail.com" className="flex items-center gap-1 hover:text-amber-100 transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">artyurtdisiegitim@gmail.com</span>
            </a>
            <a href="tel:+420774668988" className="flex items-center gap-1 hover:text-amber-100 transition-colors">
              <Phone size={14} />
              +420 774 668 988
            </a>
          </div>
          <div className="hidden md:block text-xs">
            Çekya'da Eğitim Hayaliniz İçin Yanınızdayız
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-white'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <div className="text-2xl font-bold">
                <span className="text-amber-600">Art</span>
                <span className="text-gray-800">eğitim</span>
              </div>
              <div className="ml-2 text-xs text-gray-600 hidden sm:block">
                PRAG
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                    location.pathname === link.path
                      ? 'text-amber-600'
                      : 'text-gray-700'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <Link
              to="/iletisim"
              className="hidden lg:block bg-amber-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-amber-700 transition-colors shadow-md hover:shadow-lg"
            >
              Ücretsiz Danışmanlık
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-700 hover:text-amber-600 transition-colors"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t shadow-lg">
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-base font-medium transition-colors hover:text-amber-600 ${
                    location.pathname === link.path
                      ? 'text-amber-600'
                      : 'text-gray-700'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/iletisim"
                onClick={() => setIsMobileMenuOpen(false)}
                className="bg-amber-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-amber-700 transition-colors text-center"
              >
                Ücretsiz Danışmanlık
              </Link>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;